import React from 'react';
import Image from 'next/image';
import { Flex, Link } from '@chakra-ui/react';

interface PodcastLogoBlockProps {
  amazonPodcastLogo?: string;
  applePodcastLogo?: string;
  spotifyPodcastLogo?: string;
  amazonPodcastLink?: string;
  applePodcastLink?: string;
  spotifyPodcastLink?: string;
}

function PodcastLogoBlock(props: PodcastLogoBlockProps) {
  const logoHeight = 45;
  const logoWidth = 45;

  return (
    <Flex gap="24px">
      {props.amazonPodcastLogo && props.amazonPodcastLink && (
        <Link href={props.amazonPodcastLink} isExternal>
          <Image src={props.amazonPodcastLogo} width={logoWidth} height={logoHeight} alt="Amazon Podcast Logo" unoptimized />
        </Link>
      )}
      {props.applePodcastLogo && props.applePodcastLink && (
        <Link href={props.applePodcastLink} isExternal>
          <Image src={props.applePodcastLogo} width={logoWidth} height={logoHeight} alt="Apple Podcast Logo" unoptimized />
        </Link>
      )}
      {props.spotifyPodcastLogo && props.spotifyPodcastLink && (
        <Link href={props.spotifyPodcastLink} isExternal>
          <Image src={props.spotifyPodcastLogo} width={logoWidth} height={logoHeight} alt="Spotify Podcast Logo" unoptimized />
        </Link>
      )}
    </Flex>
  );
}

export default PodcastLogoBlock;
